import React from "react";
import ReactDOM from "react-dom";
import "./Badge.scss";

export default function Badges({ badgesInfo }) {
  // If badge is not enabled, render nothing
  if (!badgesInfo?.badge) return null;

  const { badgePosition, badgeImages = {} } = badgesInfo;

  // Function to render a single or multiple badges for a position
  const renderBadge = (position, containerId) => {
    const badges = badgeImages[position]; // could be single object or array
    if (!badges) return null;

    // Normalize to array
    const badgeArray = Array.isArray(badges) ? badges : [badges];
 // Check if there are multiple badges for this position
    const isMultiplebadges = badgeArray.length > 1;

    // Add or remove class on the existing parent
    const container = document.getElementById("rightBadge");
    if (container) {
      if (isMultiplebadges) {
        container.classList.add("multiple_badges");
      } else {
        container.classList.remove("multiple_badges");
      }
    }
    return badgeArray.map((badge, index) => {
      const style = {
        width: badge.width || "auto",
        height: badge.height || "auto",
      };

      // Keep portals like before
      return ReactDOM.createPortal(
        <div
          key={`${position}_${index}`}
          className={`badge ${position}`}
          id={`badgeVisibility_${position}_${index}`} // unique ID
        >
          <img className="icon" src={badge.src} alt={`${position} badge`} style={style} />
        </div>,
        document.getElementById(containerId) // render to the same container
      );
    });
  };

  return (
    <>
      {badgePosition?.includes("default") && renderBadge("default", "defaultBadge")}
      {badgePosition?.includes("left") && renderBadge("left", "leftBadge")}
      {badgePosition?.includes("right") && renderBadge("right", "rightBadge")}
    </>
  );
}
